angular.module('lingoda.fields.radio', [])
.controller('RadioController', ['$scope', function($scope) {
    $scope.radio = {};
    $scope.radioCheck = {};
}])
.directive('collapse', ['$timeout', function($timeout) {
    return {
        restrict: 'C',
        link: function(scope, iElement, iAttrs) {
            iElement.on('hide hide.bs.collapse', function(e) {
                if(!angular.element(e.target).hasClass('collapse')) {
                    return true;
                }
                scope.collapsed = true;
                if(iAttrs.collapseHide) {
                    scope.$eval(iAttrs.collapseHide);
                }
                $timeout(function() {
                    scope.$apply()
                });
            }).on('show show.bs.collapse', function(e) {
                if(!angular.element(e.target).hasClass('collapse')) {
                    return true;
                }
                scope.collapsed = false;
                if(iAttrs.collapseShow) {
                    scope.$eval(iAttrs.collapseShow);
                }
                $timeout(function() {
                    scope.$apply()
                });
            });
        }
    }
}])
//Old directive
.directive('accordionToggle', ['$timeout', function($timeout) {
    return {
        restrict: 'C',
        link: function(scope, iElement) {
            iElement.on('click', function(e) {
                $timeout(function() {
                    if(!iElement.hasClass('accordion-collapsed')) {
                        iElement.find(':radio').attr('checked', true);
                        scope.$broadcast('ling:radio:select', iElement.find(':radio').val());
                    }
                });
                if(iElement.find(':radio').length && !iElement.hasClass('accordion-collapsed')) {
                    e.preventDefault();
                    e.stopPropagation();
                }

            });
        }
    }
}])
.directive('lingRadio', ['$compile', '$timeout', '$interval', '$parse', function ($compile, $timeout, $interval, $parse) {
    return {
        restrict:'A',
        controller: 'RadioController',
        link: function(scope, iElement, iAttrs) {

            var parentTagName = iElement.parent().prop("tagName") === 'LABEL' ? 'span' : 'label',
                newElement = angular.element('<' + parentTagName + ' class="form-ling-radio"></' + parentTagName + '>'),
                model = iAttrs.ngModel ? iAttrs.ngModel : 'radio[\'' + iElement.attr('name') + '\']';

            iElement.replaceWith(newElement);
            iElement.removeAttr('data-ling-radio');
            iElement.removeAttr('ling-radio');
            newElement.append(iElement);
            iAttrs.$set('ngModel', model);
            if(iAttrs.size) {
                newElement.addClass(iAttrs.size);
            }
            $compile(newElement)(scope);

            var sync = function(value) {
                $timeout(function() {
                    //Init models
                    if(!scope.radioCheck[iElement.attr('name')]) {
                        scope.radioCheck[iElement.attr('name')] = {};
                    }
                    if(!scope.radioCheck[iElement.attr('name')]['value-' + iAttrs.value]) {
                        scope.radioCheck[iElement.attr('name')]['value-' + iAttrs.value] = false;
                    }

                    if(value === iAttrs.value) {
                        scope.lastRadioValue = value;
                        scope.radioCheck[iElement.attr('name')]['value-' + iAttrs.value] = true;
                        newElement.addClass('checked');
                    } else if (typeof value !== 'undefined') {
                        scope.radioCheck[iElement.attr('name')]['value-' + iAttrs.value] = false;
                        newElement.removeClass('checked');
                    }
                });
            };

            //Sync
            scope.$watch(model, sync);
            scope.$on('ling:radio:select', function(e, value) {
                sync(value);
            });

            scope.$on('ling:radio:clear', function(e, value) {
                sync(null);
                scope.radio[iElement.attr('name')] = null;
            });

            //Default
            if(!!iElement.attr('checked')) {
                var checkedIntervalID = $interval(function() {
                    if(scope.radioCheck && scope.radioCheck[iElement.attr('name')]) {
                        $interval.cancel(checkedIntervalID);
                        scope.radioCheck[iElement.attr('name')]['value-' + iAttrs.value] = true;
                        $parse(iAttrs.ngModel).assign(scope, iAttrs.value);
                        $timeout(function() {
                            scope.$emit('ling:radio:initialized');
                        });
                    }
                }, 50);
            }

        }
    };
}])
.directive('lingRadioBox', function () {
    return {
        restrict:'A',
        controller: 'RadioController',
        link: function(scope, iElement) {
            var radio = iElement.find('.form-ling-radio input'),
                checkModel = 'radioCheck[\'' + radio.attr('name') + '\'][\'value-' + radio.val() + '\']';

            scope.$watch(checkModel, function(value) {
                if(value) {
                    iElement.addClass('checked');
                } else {
                    iElement.removeClass('checked');
                }
            });
        }
    };
});
